import CommissionReport from '@/pages/CommissionReport';

export default function MobileCommissionReportScreen() {
  return <CommissionReport />;
}
